import { Button } from "@/components/ui/button";
import { cx } from "@/utils/cx";
import { Plus } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";

const sizes = {
    xs: { root: "size-6", icon: "size-4" },
    sm: { root: "size-8", icon: "size-4" },
    md: { root: "size-10", icon: "size-5" },
};

interface AvatarAddButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
    size: "xs" | "sm" | "md";
    title?: string;
    className?: string;
    isDisabled?: boolean;
    onPress?: () => void;
}

export const AvatarAddButton = ({ size, className, title = "Adicionar usuário", isDisabled, onPress, ...props }: AvatarAddButtonProps) => (
    <Button
        {...props}
        type="button"
        variant="outline"
        size="icon"
        title={title}
        aria-label={title}
        disabled={isDisabled || props.disabled}
        onClick={onPress}
        className={cx(
            "cursor-pointer rounded-full border-dashed text-muted-foreground hover:text-foreground disabled:opacity-50",
            sizes[size].root,
            className,
        )}
    >
        <Plus aria-hidden className={cx("text-current", sizes[size].icon)} />
    </Button>
);
